import { AnyAction, Reducer } from 'redux';
import { updateObject } from '../../utils/utility';

import { PayerInitialState } from '../models/payerListModel';
import actionTypes from '../types/payerListTypes';
import controlConfig from '../../config/formControlConfig/defaultConfig.json';

const initialState: PayerInitialState = {
  payer: {
    id: 0,
    name: '',
    isGovtScheme: false,
    isInsurer: true,
    uniqueIdentifier: '0',
    isDefaultPayer: false,
    key: '0',
    payerConfigurableProperties: {},
    shortName: '',
    isClaimSubmissionDisabled: false,
    blockedActions: {},
    networkActivationMessage: '',
    isInitialDischargeEnabledPayer: false,
  },
  formControlConfig: controlConfig,
  defaultControlConfig: controlConfig,
  allPayers: [],
  reimbursementPayers: [],
  grievancePayers: [],
};

const changePayer = (state: PayerInitialState, { payload: payer }: AnyAction): PayerInitialState => {
  const updatedPayer = payer && Object.keys(payer).length > 0 ? payer : initialState.payer;
  return updateObject(state, { payer: updatedPayer });
};

const updateFormControlConfig =
  (state: PayerInitialState, { payload: formControlConfig }: AnyAction): PayerInitialState => {
    return updateObject(state, { formControlConfig });
  };

const setAllPayers = (state: PayerInitialState, { payload: allPayers }: AnyAction): PayerInitialState => {
  return updateObject(state, { allPayers });
};

const setReimbursementPayers = (state: PayerInitialState, { payload: reimbursementPayers }: AnyAction): PayerInitialState => {
  return updateObject(state, { reimbursementPayers });
};

const setGrievancePayers = (state: PayerInitialState, { payload: grievancePayers }: AnyAction): PayerInitialState => {
  return updateObject(state, { grievancePayers });
};

const reducer: Reducer<PayerInitialState> = (state: PayerInitialState = initialState, action: AnyAction): any => {
  switch (action.type) {
    case actionTypes.CHANGE_PAYER:
      return changePayer(state, action);
    case actionTypes.UPDATE_FORM_CONTROL_CONFIG:
      return updateFormControlConfig(state, action);
    case actionTypes.SET_ALL_PAYERS:
      return setAllPayers(state, action);
    case actionTypes.SET_REIMBURSEMENT_PAYERS:
      return setReimbursementPayers(state, action);
    case actionTypes.SET_GRIEVANCE_PAYERS:
      return setGrievancePayers(state, action);
    case actionTypes.SET_EXACT_FILE_COUNT: {
      state.payer.exactFileCount = action.payload;
      return state;
    }
    default: return state;
  }
};

export { reducer as payerReducer };
